import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';
import * as moment from 'moment';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';

import {MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA, MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {AlertaConfirmDialog} from '../alerta-confirm';
import {AlertaSimplesDialog} from '../alerta-simples';

@Component({
  selector: 'app-me-cardapio',
  templateUrl: './me-cardapio.component.html',
  styleUrls: ['./me-cardapio.component.css'],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'ja-JP'},
]
})
export class MeCardapioComponent implements OnInit {

  existeTreino: boolean = false;
  hideCL: boolean = false;
  nomeDS: any = '';
  numDS: any = 0;
  numDM: any = 0;
  meuIdDieta: any = 0;
  arrNomesDS: any[] = [ 'domingo', 'segunda feira', 'terça feira', 'quarta feira', 'quinta feira', 'sexta feira', 'sábado'];
  arrRefeicoesDia: any[] = [];
  arrRefeicoesOP: any[] = [];
  arrRefeicoesFirst: any[] = [];
  exibindoDataOne: string;
  dataPicked: Date;
  minDate: Date;
  maxDate: Date;
  timeoutHandler: any;
  mBottomOpc: any;
  mBottomNot: any;
  qCheck: boolean = false;
  constructor(private bottomSheet: MatBottomSheet, private route: ActivatedRoute, private _location: Location, public router: Router, public tmaService: TamasAlunoService, public dialog: MatDialog) {

    route.params.subscribe(val =>{
      this.funcaoInicial();
    })
   }

  ngOnInit() {
    //this.funcaoInicial();
    
  }
  funcaoInicial(){
    moment.locale('pt');

    this.hideCL = true;
    this.existeTreino = true;
    const qDia = +this.route.snapshot.paramMap.get('diadasemana');
    this.meuIdDieta = this.route.snapshot.paramMap.get('iddieta');
    this.numDS = qDia;
    this.nomeDS = this.arrNomesDS[qDia];
    this.numDM = this.route.snapshot.paramMap.get('datacompleta');
    console.log(this.numDS);
    console.log(this.tmaService.arrRefeicoesDone);
    this.montarRefeicoes();
    //var dataTeste = moment(new Date()).format("DD/MM/YYYY");
    //this.exibindoDataOne = dataTeste;
    // var minCurrentDate = new Date();
    // var maxNewDate = new Date();
   
    var dataMax = moment(new Date()).format("MM/DD/YYYY");
    //this.maxDate  = maxNewDate.setMonth(maxNewDate.getMonth() +1);
    //this.maxDate = new Date(dataMax);
    this.minDate = new Date(moment(new Date()).startOf('month').format('MM/DD/YYYY'));
    this.maxDate = new Date( moment(new Date()).endOf('month').format('MM/DD/YYYY'))
    console.log(this.minDate, this.maxDate);

    //verificar se é uma data válida
    var bPeriodo = this.route.snapshot.paramMap.get('datacompleta');
    var periodoFormatado = bPeriodo.replace(/\-/g,'/');
    this.exibindoDataOne = periodoFormatado;
    var dataValida = moment(periodoFormatado, 'DD/MM/YYYY');

    console.log(periodoFormatado);
    console.log(dataValida.isValid());
    if(dataValida.isValid()){
      console.log("valida");
      console.log(dataValida.format('DD/MM/YYYY'));
    }
  }

  dataSelecionada() :void{
    console.log("foi");
    console.log(this.dataPicked);
    if(this.dataPicked !== undefined && this.dataPicked !== null){
        console.log(this.dataPicked);
        this.exibindoDataOne = this.dataPicked.toLocaleDateString();
        console.log(this.exibindoDataOne.replace(/\//g,'-'));
        var dataFormatada = this.exibindoDataOne.replace(/\//g,'-');
        this.router.navigate(['/me/cardapio/' + this.meuIdDieta + '/' + this.dataPicked.getDay() + '/' + dataFormatada], {replaceUrl: true});
        //this.router.navigate(['/dashboard/consultas/' + dataFormatada]);
    }
}

popAlertaSimples(msg: any) :void{
  const simplesA = this.dialog.open(AlertaSimplesDialog, {
    width: '250px',
    data: {textoAlerta: msg}
    });
}

goPrev() :void{
  //pegar parametro
  
  var dataTeste = new Date();
  var mesAtual = dataTeste.getMonth();
  var periodoAtualF = this.route.snapshot.paramMap.get('datacompleta').replace(/\-/g,'/');
  var periodoATV = moment(periodoAtualF, 'DD/MM/YYYY');
  if(periodoATV.isValid()){
    
      var novaData = moment(this.route.snapshot.paramMap.get('datacompleta'), 'DD-MM-YYYY').add('days', -1);
      console.log(mesAtual, novaData.month());
      if(mesAtual ==  novaData.month()){
        this.router.navigate(['/me/cardapio/' + this.meuIdDieta + '/' +  novaData.day() + '/' + novaData.format('DD-MM-YYYY')], {replaceUrl: true});
        //this.router.navigate(['/me/inbox'], {replaceUrl: true});
      }
      else{
        this.popAlertaSimples("É possível visualizar apenas as refeições do mês atual");
        console.log("apenas este mês é possível acessar");
        
      }
      //this.router.navigate(['/dashboard/consultas/' + novaData.format('DD-MM-YYYY')]);
  }
  else{
    
      // var periodoAtual = Number(this.route.snapshot.paramMap.get('periodo'));
      //  //subtrair
      // periodoAtual = periodoAtual + 1;
      // this.router.navigate(['/dashboard/consultas/' + periodoAtual]);
      // //this.carregarConsultasOne(periodoAtual);
  }
 
}
goNext() :void{
  //pegar parametro
  var dataTeste = new Date();
  var mesAtual = dataTeste.getMonth();
  var periodoAtualF = this.route.snapshot.paramMap.get('datacompleta').replace(/\-/g,'/');
  var periodoATV = moment(periodoAtualF, 'DD/MM/YYYY');
  if(periodoATV.isValid()){
      var novaData = moment(this.route.snapshot.paramMap.get('datacompleta'), 'DD-MM-YYYY').add('days', 1);
      if(mesAtual ==  novaData.month()){
        this.router.navigate(['/me/cardapio/' + this.meuIdDieta + '/' +  novaData.day() + '/' + novaData.format('DD-MM-YYYY')], {replaceUrl: true});
        //this.router.navigate(['/me/inbox'], {replaceUrl: true});
      }
      else{
        this.popAlertaSimples("É possível visualizar apenas as refeições do mês atual");
        console.log("apenas este mês é possível acessar");
      }
  }
  else{
      // var periodoAtual = Number(this.route.snapshot.paramMap.get('periodo'));
      // //subtrair
      // periodoAtual = periodoAtual + -1;
      // this.router.navigate(['/dashboard/consultas/' + periodoAtual]);
      // //this.carregarConsultasOne(periodoAtual);
  }
 
}

  montarRefeicoes() : void{
    //buscar no servidor com base no dia atual
    this.hideCL = false;
    this.arrRefeicoesDia = [];
    this.arrRefeicoesOP = [];
    this.arrRefeicoesFirst = [];
    var gDados = 'idplano=' + this.meuIdDieta + '&diaSemana=' + this.numDS + '&minhadata=' + this.numDM.replace(/\-/g,'/') + '&email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha; 
    this.tmaService.listarRefeicoesD(gDados)
    .subscribe((qRes) =>{
      console.log(qRes);
      var fkarrRefeicoes = qRes['arrRefeicoes'];
      var fkArrDone = qRes['arrRefDone'];
      var fkarrNotify = qRes['arrNotificacoes'];
      this.arrRefeicoesOP = qRes['arrRefOpcoes'];
      
      if(fkarrRefeicoes == undefined){

      }
      else{
        fkarrRefeicoes.forEach(item => {
          //primeira opção
          this.arrRefeicoesFirst.push(this.arrRefeicoesOP.find(x => x.IdRefeicao == item.id));
          var qHora = moment(item.horario.Hours + ':' + item.horario.Minutes,'HH:mm' ).format("HH:mm");
          var shouldNotify = false;
          console.log("vamos olhar " + qHora);
          
          if(fkarrNotify.find(x => x.horarioNotificar.Ticks == item.horario.Ticks)){
            //console.log(fkarrNotify[0].horarioNotificar.Hours);
            console.log("deve notificar");
            shouldNotify = true;
          }
  
          //verifica se existem opções
          var existeOpcoes = false;
          if(this.arrRefeicoesOP.filter(x => x.IdRefeicao == item.id).length > 1){
            existeOpcoes = true;
          }
  
          if(fkArrDone.find(x => x.idRefeicao == item.id)){
            //já realizou refeicao
            this.arrRefeicoesDia.push({ idRefeicao: item.id, nomeRefeicao: item.refeicao, numeroDS: this.numDS, horario: qHora, done: true, ck: true, notfy : shouldNotify, eOpcoes: existeOpcoes, obs: item.obs });    
          }
          else{
            this.arrRefeicoesDia.push({ idRefeicao: item.id, nomeRefeicao: item.refeicao, numeroDS: this.numDS, horario: qHora, done: false, ck: false, notfy : shouldNotify,  eOpcoes: existeOpcoes, obs: item.obs });    
          }
        });
      }
      
      this.hideCL = true;
    })

    //this.arrRefeicoesDia.push({ idRefeicao: 1, nomeRefeicao: 'Café da manhã', numeroDS: this.numDS, horario: '09:00', done: true, ck: true, notfy : false });
    // this.arrRefeicoesDia.push({ idRefeicao: 2, nomeRefeicao: 'Almoço', numeroDS: this.numDS, horario: '12:00', done: false, ck: false, notfy : false });
    // if(this.numDS !== 3 && this.numDS !== 5){
    //   this.arrRefeicoesDia.push({ idRefeicao: 3, nomeRefeicao: 'Pré Treino', numeroDS: this.numDS, horario: '17:00', done: false, ck: false, notfy : true });
    //   this.arrRefeicoesDia.push({ idRefeicao: 4, nomeRefeicao: 'Pós Treino', numeroDS: this.numDS, horario: '19:30', done: false, ck: false, notfy : false });
      
    // }
    // this.arrRefeicoesDia.push({ idRefeicao: 5, nomeRefeicao: 'Jantar', numeroDS: this.numDS, horario: '21:00', done: false, ck: false });
    // //terá que retornar do servidor, se a refeicao foi feita, com base na data
    // this.arrRefeicoesDia.forEach(qItem => {
    //   if(this.tmaService.arrRefeicoesDone.find(x => x.idRefeicao == qItem.idRefeicao && x.numeroDS == qItem.numeroDS)){
    //     //var qIndexRef = this.arrRefeicoesDia.findIndex(x => x.idRefeicao == qItem.idRefeicao)
    //     this.arrRefeicoesDia.find(x => x.idRefeicao == qItem.idRefeicao && x.numeroDS == qItem.numeroDS).done = true;
    //   }
    // });
    
  }

  onEdit($e : any, idRefeicao: any) {
    $e.preventDefault();
    $e.stopImmediatePropagation();

    console.log("onEdit clicked " + idRefeicao);
    this.tmaService.qPagina = "cardapio";
    this.router.navigate(['me/refeicao/' + this.meuIdDieta + "/" + this.numDS + "/" + idRefeicao + "/" + this.numDM]);
  }

  goRefeicao(idRefeicao: any) :void{
    this.tmaService.qPagina = "cardapio";
    this.router.navigate(['me/refeicao/' + this.meuIdDieta + "/" + this.numDS + "/" + idRefeicao + "/" + this.numDM]);
  }
  saveRef() :void{
    //verificar as que já tinham sido feitas done = true
    //essas não há necessidade de reenviar ao servidor, então pegamos apenas as que ficaram checked agora e done = false
    this.hideCL = false;
    var idsDone = [];
    var arrEnviar = this.arrRefeicoesDia.filter(x => x.done == false && x.ck == true);
    this.arrRefeicoesDia.forEach(qItem => {
      if(qItem.ck == true && qItem.done == false){
        idsDone.push({'idRefeicao': qItem.idRefeicao});
        //maybe fix
        qItem.done = true;
      }
    });
    console.log(idsDone);
    //enviar para api

    if(idsDone.length !== 0){
      console.log("send server");
      var meuArray = JSON.stringify(idsDone);
      let customParams = {
        //lista: localStorage.getItem('turboCart'),
        email: this.tmaService.hcEmail,
        senha: this.tmaService.hcSenha,
        idplano: this.meuIdDieta,
        dataReferencia: this.numDM.replace(/\-/g,'/'),
        arrIdsRef: meuArray
    };
      //var gDados = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&idplano=' + this.meuIdDieta + '&dataReferencia=' + this.numDM.replace(/\-/g,'/')  + '&arrIdsRef=' + meuArray;
      this.tmaService.checkRefeicaoDone(customParams)
      .subscribe((qRes) =>{
        console.log(qRes);
        this.hideCL = true;
        if(qRes['res'] == 'done'){
          //this.voltar();
          this.popAlertaSimples("Alterações salvas com sucesso");
        }
      })
    }
    else{
      //do nothing, just redirect back
      this.voltar();
      //this.popAlertaSimples("Alterações salvas com sucesso");
    }


  }
  actHold(qNomeRefeicao: any, qIdRefeicao: any ){
    this.timeoutHandler = setTimeout(() => {
      this.timeoutHandler = null;
      console.log("chamar opções");
        this.verOpcoes(qNomeRefeicao, qIdRefeicao);
    }, 100);

  }
  actLeave(){
    if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler);
      this.timeoutHandler = null;
      console.log("do nothing");
    }
  }

  actClick(qNomeRefeicao: any, qIdRefeicao: any ){
    this.timeoutHandler = setTimeout(() => {
      this.timeoutHandler = null;
      console.log("chamar opções");
        this.verOpcoes(qNomeRefeicao, qIdRefeicao);
    }, 100);

  }

  verOpcoes(tbNome: any, tbId: any) :void{

    //buscar as opções no array ou algo do tipo de acordo com o idrefeicao
    //jogar as opções dentro de um novo array e passalo para a bs
    var refOpItens = this.arrRefeicoesOP.filter(x => x.IdRefeicao == tbId);
    // var qqOpc = [];
    // qqOpc.push({ op: 'Opção 1', descritivo: '200g batata doce <br>8 claras cozidas'})
    // qqOpc.push({ op: 'Opção 2', descritivo: '200g batata doce <br>8 claras cozidas'})
    // qqOpc.push({ op: 'Opção 3', descritivo: '200g batata doce <br>8 claras cozidas'})
    this.mBottomOpc = this.bottomSheet.open(BottomSheetOverviewOpcoes, {
      data: { status: "Teste", refeicao: tbNome, listaOpcoes: refOpItens  },
    });
    this.mBottomOpc.afterDismissed().subscribe((res) =>{
      console.log("bottom dismiss");
      console.log(res);
      if(res != null){
          //this.mTrocarStatus(res);
      }

    })
  }
  afectAll() :void{
    console.log(this.qCheck);
    if(this.qCheck == false){
      this.arrRefeicoesDia.forEach(element => {
        if(!element.done){
          element.ck = true;
        }
      });
    }
    else{
      this.arrRefeicoesDia.forEach(element => {
        if(!element.done){
          element.ck = false;
        }
      });
    }
    console.log(this.arrRefeicoesDia);
  }

  changeCk(idRef : any, qDone: any){
    this.arrRefeicoesDia.find(x => x.idRefeicao == idRef).ck =  qDone;
    console.log(this.arrRefeicoesDia);
    // if(this.arrRefeicoesDia.find(x => x.idRefeicao == idRef).done){
    //   this.arrRefeicoesDia.find(x => x.idRefeicao == idRef).done = false;
    // }
    // else{
    //   this.arrRefeicoesDia.find(x => x.idRefeicao == idRef).done = true;
    // }

  }
  changeT(idRef: any, qNotfy: any, tHorario: any){
    console.log(qNotfy);
    //enviar isso diretamente pro servidor?
    this.arrRefeicoesDia.find(x => x.idRefeicao == idRef).notfy =  !qNotfy;
      var acaoToDo = "";
      if(qNotfy){
        acaoToDo = "desativar";
      }
      else{
        acaoToDo = "ativar";
      }
      this.alterarNotifyE(idRef,acaoToDo,tHorario);
  }


  opDesativar() :void{
    this.mBottomNot = this.bottomSheet.open(BottomSheetOverviewNotify, {
      data: { modo: "desativar", diadasemana: this.numDS  },
    });
    this.mBottomNot.afterDismissed().subscribe((res) =>{
      console.log("bottom dismiss");
      console.log(res);
      if(res != null && res != ''){
          //obter opção e enviar pro servidor
          this.hideCL = false;
          console.log("go server " + res);
          this.alterarNotifyG('desativar', res);
        
      }

    })
  }

  opAtivar() :void{
    this.mBottomNot = this.bottomSheet.open(BottomSheetOverviewNotify, {
      data: { modo: "ativar", diadasemana: this.numDS  },
    });
    this.mBottomNot.afterDismissed().subscribe((res) =>{
      console.log("bottom dismiss");
      console.log(res);
      if(res != null && res != ''){
            //obter opção e enviar pro servidor
            this.alterarNotifyG('ativar', res);
            // this.hideCL = false;
            // var qAcao = 'ativar ' + res;
            // var gDados = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&idplano=' + this.meuIdDieta + '&ds=' + this.numDS + '&datareferencia=' + this.numDM.replace(/\-/g,'/') + '&acao=' + qAcao;
            // this.tmaService.alterarNotificacoesG(gDados)
            // .subscribe((qRes) =>{
            //   console.log(qRes);
            //   this.hideCL = true;
            // })
      }
    })
  }

  alterarNotifyG(qTipo: any, qParametro: any){
    this.hideCL = false;
    var qAcao = qTipo + ' ' + qParametro;
    var gDados = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&idplano=' + this.meuIdDieta + '&ds=' + this.numDS + '&datareferencia=' + this.numDM.replace(/\-/g,'/') + '&acao=' + qAcao;
    this.tmaService.alterarNotificacoesG(gDados)
    .subscribe((qRes) =>{
      console.log(qRes);
      if(qTipo == 'desativar'){
        //this.arrRefeicoesDia.filter(x => x.idRefeicao == idRef).notfy =  false;
        this.arrRefeicoesDia.forEach((itemRef, index) => {
          this.arrRefeicoesDia[index].notfy =  false;
        });
      }
      else{
        this.arrRefeicoesDia.forEach((itemRef, index) => {
          this.arrRefeicoesDia[index].notfy =  true;
        });
      }
      this.hideCL = true;
    })
  }
  
  alterarNotifyE(qRefeicao: any, qTipo: any, qHorario: any){
    this.hideCL = false;
    var gDados = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&idplano=' + this.meuIdDieta + '&idrefeicao=' + qRefeicao + '&ds=' + this.numDS + '&datareferencia=' + this.numDM.replace(/\-/g,'/') + '&horario=' + qHorario + '&acao=' + qTipo;
    this.tmaService.alterarNotificacoesE(gDados)
    .subscribe((qRes) =>{
      console.log(qRes);
      this.hideCL = true;
    })
  }


  voltar() :void{
    //this._location.back();
    if(this.tmaService.paginaAnterior == 'home'){
      this.router.navigate(['/home']);
    }
    else{
      this.router.navigate(['me/dietas' ]);
    }
  }
}

@Component({
  selector: 'bottom-sheet-opcoes',
  templateUrl: 'bottom-sheet-opcoes.html',
  styleUrls: ['./bottom-sheet-opcoes.css']
})
export class BottomSheetOverviewOpcoes {
  statusAtual: any;
  qtdRepeticoes: any = 0;
  qtdSeries: any = 0;
  nomeExercicio: any = '';
  tempoDescanso: any = 0;
  //aqui vai ser o fator do array e o localstorage
  qIdExercicio: any = 0;
  arrHistExercicio: any[] = [];
  nSerieAtual: any = 0;
  arrOpcoes: any[] = [];
  refeicaoAtual: any = '';
  
  constructor(private bottomSheetRef: MatBottomSheetRef<BottomSheetOverviewOpcoes>, @Inject(MAT_BOTTOM_SHEET_DATA) public data: any, public dialog: MatDialog, public tmaService: TamasAlunoService) {
      
  }
  ngOnInit(){
      console.log(this.data);
      this.statusAtual = this.data.status;
      this.qtdSeries = this.data.qtdSeries;
      this.tmaService.glTotalSeries = this.qtdSeries;
      this.tmaService.glSerieAtual = 0;
      this.nomeExercicio = this.data.nomeExercicio;
      this.qtdRepeticoes = this.data.qtdRepeticoes;
      this.tempoDescanso = this.data.tempoDescanso;
      this.qIdExercicio = this.data.idExercicio;
      this.arrOpcoes = this.data.listaOpcoes;
      this.refeicaoAtual = this.data.refeicao;
     for(var i = 1; i <= this.qtdSeries ; i++){
       if(this.tmaService.arrSeriesRlz.find( s => s.mtIdExercicio == this.qIdExercicio && s.mtNumSerie == i)){
        this.arrHistExercicio.push({ qNumSerie: i, qNumrepet: this.qtdRepeticoes,  qPeso: 0, checked: true, qIdExercicio: this.qIdExercicio });
       }
       else{
        this.arrHistExercicio.push({ qNumSerie: i, qNumrepet: this.qtdRepeticoes,  qPeso: 0, checked: false, qIdExercicio: this.qIdExercicio });
       }
        

     }

  }
 
  qStatus(novoStatus: any): void {

      if(novoStatus != undefined){
          const avisoData = this.dialog.open(AlertaConfirmDialog, {
              // width: '250px',
              disableClose: true,
              data: {iconAlerta: "warning", tituloAlerta: "Alterar Status", textoAlerta: "Confirma a alteração do status para <b>"+ novoStatus + "</b>?", textoCancel: "Não", textoConfirm: "SIM"}
          });
          avisoData.afterClosed().subscribe((result) =>{
              console.log(result);
              if(result == true){
                  this.bottomSheetRef.dismiss(novoStatus);
                  
              }
              else{
                 
              }
          })
      }
      
      event.preventDefault();
  }
}

@Component({
  selector: 'bottom-sheet-notify',
  templateUrl: 'bottom-sheet-notify.html',
  styleUrls: ['./bottom-sheet-notify.css']
})
export class BottomSheetOverviewNotify {
  
  refeicaoAtual: any = '';
  tipoNotify: any = '';
  frasediaSemana: any = '';
  opDesativar: any = '';
  opAtivar: any = '';
  constructor(private bottomSheetRef: MatBottomSheetRef<BottomSheetOverviewNotify>, @Inject(MAT_BOTTOM_SHEET_DATA) public data: any, public dialog: MatDialog, public tmaService: TamasAlunoService) {
      
  }
  ngOnInit(){
      console.log(this.data);
      this.tipoNotify = this.data.modo;
     if(this.data.diadasemana == 0){
        this.frasediaSemana = 'todos os domingos';
     }
    if(this.data.diadasemana == 1){
      this.frasediaSemana = 'todas as segundas';
     }
     if(this.data.diadasemana == 2){
      this.frasediaSemana = 'todas as terças';
    }
    if(this.data.diadasemana == 3){
      this.frasediaSemana = 'todas as quartas';
    }
    if(this.data.diadasemana == 4){
      this.frasediaSemana = 'todas as quintas';
    }
    if(this.data.diadasemana == 5){
      this.frasediaSemana = 'todas as sextas';
    }
    if(this.data.diadasemana == 6){
      this.frasediaSemana = 'todos os sábados';
    }

  }

  changesNotify() :void{
    console.log(this.opDesativar, this.opAtivar);
    if(this.tipoNotify == 'ativar'){
      this.bottomSheetRef.dismiss(this.opAtivar);
    }
    else{
      this.bottomSheetRef.dismiss(this.opDesativar);
    }

  }
}

